import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../SectionHeading';
import { cardHover, slideInLeft, slideInRight, viewportTall } from '../motion';
import EIP from "../Logos/Code-editor.avif";
import LangGuard from "../Logos/micro.webp";
import SchemaSenseAI from "../Logos/SenseAI.png";
import HRM from "../Logos/HRM.png";

function Project() {
  const projects = [
    {
      img: HRM,
      title: "HRM AI AGENT",
      description: "An intelligent AI-powered Human Resource Management assistant that provides personalized responses to employee queries. Built with FastAPI and Mistral AI, the system retrieves real-time data from the database based on the logged-in user's credentials and generates contextual, personalized answers. All HR features are accessible through a conversational interface, putting comprehensive HR support right at employees' fingertips.",
      url: "https://github.com/Mayuradlak123/HRM-AI-Agent"
    },
    {
      img: EIP,
      title: "Engineering Intelligence Platform (EIP)",
      description: "An advanced Software Engineering Intelligence platform designed to aggregate data from Git repositories, Jira, and CI/CD pipelines to track DORA metrics, analyze workflow bottlenecks, and optimize developer productivity. It provides engineering leaders with actionable, data-driven insights to streamline the software delivery process and align engineering efforts with key business objectives.",
      url: "https://github.com/Mayuradlak123/Engineering-Intelligence-Platform-EIP-"
    },
    {
      img: SchemaSenseAI,
      title: "SchemaSense-AI ( GenAI-Powered Natural Language Query Engine )",
      description: "SchemaSense-AI is a cutting-edge GenAI-powered natural language query engine that bridges the gap between human language and complex database schemas. It enables users to interact with their data using simple, conversational queries, transforming raw database schemas into intuitive, business-friendly interfaces. It supports MySQL, PostgreSQL, SQLite, and MongoDB to manage multiple database storage agent systems, built with FastAPI to ensure a maintained structure for every tool.",
      url: "https://github.com/Mayuradlak123/SchemaSense-AI"
    },
    {
      img: LangGuard,
      title: "langguard-core ( Lightweight LLM Guardrails & Security Framework )",
      description: "langguard-core is an open-source, lightweight security and guardrails framework for Large Language Model (LLM) applications. It provides real-time detection and mitigation of prompt injections, jailbreaks, PII leaks, toxic language, and hallucinatory outputs. Built as a PyPI package, it seamlessly integrates as middleware into any Python-based LLM pipeline or FastAPI application to ensure safe and aligned AI behavior.",
      url: "https://github.com/Mayuradlak123/langguard-core"
    }
  ];

  return (
    <div id="projects" className="py-20 relative overflow-hidden">
      {/* Decorative blobs */}
      <div className="absolute top-20 left-10 w-40 h-40 bg-purple-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob-slow"></div>
      <div className="absolute bottom-10 right-10 w-32 h-32 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob-medium"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <SectionHeading eyebrow="Selected work" title="Projects" className="mb-16">
          Products I've designed and built end to end, from agentic AI systems to the
          infrastructure that keeps them safe.
        </SectionHeading>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {projects.map((project, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden hover:shadow-2xl transition-shadow duration-500 flex flex-col h-full"
              variants={index % 2 === 0 ? slideInLeft : slideInRight}
              initial="hidden"
              whileInView="visible"
              viewport={viewportTall}
              whileHover={cardHover}
            >
              <div className="overflow-hidden h-64 relative group bg-slate-900 flex items-center justify-center p-2">
                <img
                  src={project.img}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 object-center rounded-2xl"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
                  <span className="text-white text-xs font-semibold uppercase tracking-wider bg-blue-600/90 px-3 py-1 rounded-full font-sans">
                    Explore Project
                  </span>
                </div>
              </div>
              <div className="p-8 flex flex-col flex-grow justify-between">
                <div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-3 hover:text-blue-700 transition duration-300 font-sans">{project.title}</h3>
                  <p className="text-gray-600 text-sm mb-6 leading-relaxed text-justify font-sans">{project.description}</p>
                </div>
                <div className="pt-4 border-t border-gray-100 flex items-center justify-between">
                  <a
                    href={project.url}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center px-6 py-2.5 text-sm font-semibold text-white bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 rounded-full hover:from-blue-800 hover:to-indigo-900 transition duration-300 shadow-md hover:shadow-lg transform hover:scale-105 font-sans"
                  >
                    View Project 
                    <svg className="w-4 h-4 ml-2 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </a>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Project;
